import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

function ActionButtons({ row, onEdit, onReset, onDelete, t }) {
  const crl = row.original;
  return (
    <>
      <MDButton
        variant="text"
        color="info"
        onClick={() => onEdit(crl)}
        title={t ? t("crls.table.actions.edit", "Edit") : "Edit"}
      >
        <Icon>edit</Icon>
      </MDButton>
      <MDButton
        variant="text"
        color="warning"
        onClick={() => onReset(crl)}
        title={t ? t("crls.table.actions.resetPassword", "Reset Password") : "Reset Password"}
      >
        <Icon>lock_reset</Icon>
      </MDButton>
      <MDButton
        variant="text"
        color="error"
        onClick={() => onDelete(crl)}
        title={t ? t("crls.table.actions.delete", "Delete") : "Delete"}
      >
        <Icon>delete</Icon>
      </MDButton>
    </>
  );
}

ActionButtons.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.object.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  t: PropTypes.func,
};

ActionButtons.defaultProps = {
  t: null,
};

export default function CrlsDataTable({ crls, onEdit, onReset, onDelete, t, showActions = true }) {
  const columns = [];

  if (showActions) {
    columns.push({
      Header: t ? t("crls.table.columns.actions", "Actions") : "Actions",
      accessor: "actions",
      Cell: (props) => (
        <ActionButtons {...props} onEdit={onEdit} onReset={onReset} onDelete={onDelete} t={t} />
      ),
      width: "150px",
    });
  }

  columns.push(
    {
      Header: t ? t("crls.table.columns.name", "Name") : "Name",
      accessor: "name",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("crls.table.columns.phoneNo", "Phone No") : "Phone No",
      accessor: "phone_no",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("crls.table.columns.email", "Email") : "Email",
      accessor: "email",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: t ? t("crls.table.columns.username", "Username") : "Username",
      accessor: "username",
      Cell: ({ value }) => value || "-",
    }
  );

  const rows = crls.map((crl) => ({
    ...crl,
    actions: "",
  }));

  return {
    columns,
    rows,
  };
}

CrlsDataTable.propTypes = {
  crls: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onReset: PropTypes.func,
  onDelete: PropTypes.func,
  t: PropTypes.func,
  showActions: PropTypes.bool,
};

CrlsDataTable.defaultProps = {
  onEdit: undefined,
  onReset: undefined,
  onDelete: undefined,
  t: null,
  showActions: true,
};
